//@ts-check
import React, {DetailedHTMLProps, InputHTMLAttributes, PureComponent} from 'react';
import {omit} from 'ramda';
import Flag from '../../Flag';
import classNames from 'classnames';
import styles from './TextInput.scss';
import {bodyText3} from '../../Typography';

const ErrorPopover = ({children}: {children: string}) =>
  <div className={classNames(styles.errorMessage, bodyText3.toString())}>
    <div className={styles.caretUp}/>{children}
  </div>;


type ReactTextInput = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

// eslint-disable-next-line no-undef
interface TextInputProps extends Omit<ReactTextInput, 'size' | 'type' | 'value' | 'className'> {
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => any;
  className?: string | string[];
  errorMessage?: string | false;
  type?: 'date' | 'datetime-local' | 'email' | 'month' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'time' | 'url' | 'week';
  theme?: 'light' | 'dark' | 'default' | 'transparent';
  size?: 'medium' | 'large';
  errorStyle?: 'inside' | 'below';
  onFocus?: () => void;
}

class TextInput extends PureComponent<TextInputProps> {
  ref: React.RefObject<HTMLInputElement>;

  static defaultProps = {
    className: null,
    errorMessage: '',
    theme: 'default',
    size: 'medium',
    type: 'text',
    errorStyle: 'inside',
    disabled: false,
    placeholder: '',
  };

  constructor(props){
    super(props);
    this.ref = React.createRef();
  }

  render() {
    const {className, errorMessage, theme, size, errorStyle} = this.props;
    const inputProps = omit(['className', 'errorMessage', 'theme', 'size', 'errorStyle'], this.props);
    const textInputStyles = classNames(styles.TextInput, styles[`theme-${theme}`], styles[`size-${size}`]);

    return (
      <div className={textInputStyles}>
        <input
          ref={this.ref}
          className={classNames(styles.input, {[styles.warning]: errorMessage}, className)}
          {...inputProps}
        />
        {errorMessage && (
          errorStyle === 'inside'
            ? <Flag>{errorMessage}</Flag>
            : <ErrorPopover>{errorMessage}</ErrorPopover>
        )}
      </div>
    );
  }
}

export default TextInput;
